import { Component, OnInit, ViewChild, AfterViewInit, Input, Output  } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { ImageHandlerService } from '../../../services/vendor/image-handler.service';
import { NavigatorService, keyTypesEnum } from '../../../services/vendor/navigator.service';
import { InventoryItem, DialogNewAssetWorkOrder, DialogNewAsset, Address, MeterRecording, CMMSLocation } from '../../../data-models/models';


@Component({
    selector: 'vendor-add-asset-dialog',
    templateUrl: 'vendor-add-asset-dialog.component.html',
    styleUrls: ['vendor-add-asset-dialog.component.scss']
  })

  export class VendorAddAssetDialogComponent implements OnInit {
    @ViewChild('horizontalStepper') horizontalStepper: MatStepper; 
    public isInitialAdd: boolean = true;
    public submitForm: FormGroup; 
    public inventory: Array<InventoryItem> = []; 
    public currentDate: string; 
    public assignedId: string;
    public dateScheduled: Date;
    public viewableDateScheduled: string;
    public isDateFieldsEnabled: boolean = false;
    public isAssetCompleted: boolean = false;

    // Local Fields
    public id: string;
    public title: string;
    public barcode: string;
    public price: number;
    public desc: string;
    public located_at: CMMSLocation | string;
    public locations: Array<CMMSLocation> = [];
    public area: string;
    public gallery: Array<string>;
    public model: string;
    public serial_number: string;
    public isMetered: boolean;
    public meterRecordings: Array<MeterRecording>;
    public operational_status: string;

    public imageTest: any;

    private keyTypes: any = keyTypesEnum;

    constructor(
      private navigatorService: NavigatorService, 
      private imageHandlerService: ImageHandlerService, 
      private fb: FormBuilder, 
      private datePipe: DatePipe, 
      @Inject(MAT_DIALOG_DATA) public assetItem: any,
      public matDialogRef: MatDialogRef<VendorAddAssetDialogComponent>
      ) {
      
    }
  
    ngOnInit() {
      this.getCMMSLocations();

      if(this.assetItem) {
        this.isDateFieldsEnabled = false;
        this.viewableDateScheduled = this.datePipe.transform(new Date, "yyyy-MM-dd");
      } else {
        this.isDateFieldsEnabled = true;
        this.viewableDateScheduled = this.datePipe.transform(new Date, "yyyy-MM-dd");
        this.dateScheduled = new Date;

        // Assigned ID needs to be passed in. Currently only a fake one is used
        this.assignedId = "a936cd5699";
      }
      
      this.matDialogRef.disableClose = true;//disable default close operation

      this.currentDate = this.datePipe.transform(new Date, "yyyy-MM-dd");


      if(!this.assetItem) {
        this.submitForm = this.fb.group({

          basic: this.fb.group({
            originatorId: {value: this.navigatorService.getProfileId(), disabled: true},
            originationDate: {value: new Date, disabled: true},
            assetNumber: {value: this.navigatorService.generateKey(this.keyTypes.WORK_ORDER_ID), disabled: true},
            dateScheduled: {value: this.viewableDateScheduled, disabled: true},
            desc: [ '' , Validators.required],
            operational_status: ['', Validators.required],
            gallery: [[]]
          }),

          assetInfo: this.fb.group({
            id: [ { value: this.navigatorService.generateKey(this.keyTypes.ASSET_ID), disabled: true }, Validators.required],
            title: [ { value: '', disabled: false }, Validators.required],
            barcode: [ { value: '', disabled: false }, Validators.required],
            located_at: [ '', Validators.required],
            area: [ '' ],
            model: [ { value: '', disabled: false }, Validators.required],
            serial_number: [ '', Validators.required],
            isMetered: [false, Validators.required],
            reservation_system: [false, Validators.required],
          }),
        }); 
      } else {
        this.isInitialAdd = false;
        this.populateSubmitForm();
      }

      // this.inventory = this.navigatorService.getLocalTrackedInventory();

      // USE FOR PRODUCTION
      // this.navigatorService.getLocalTrackedFields().subscribe(data => { 
      //   if(data) {
      //     this.inventory = data; 
      //   }
      // });
    }

    public getCMMSLocations() {   
      this.navigatorService.getAsyncAllCMMSLocations().then(locations => { 
  
        if(locations) {
          console.log("Ingested CMMS Locations: ", locations);
          this.locations = locations;
        }
  
      })
    }

    // Old data type was string. There currently isn't a clean platform update setup so two data types are allowed.
    // This requires adjustment.
    translateLocation(locatedAt: CMMSLocation | string): string {
      let locationTitle: string = "";

      if(typeof locatedAt === 'string') {
        return locationTitle;
      } else {
        locationTitle = locatedAt.title;
      }

      return locationTitle
    }

    locationSelectionCompare(o1: any, o2: any) {
      return (o1.id == o2.id);
    }

    populateSubmitForm(): void {
      this.submitForm = this.fb.group({

        basic: this.fb.group({
          originatorId: {value: this.navigatorService.getProfileId(), disabled: true},
          originationDate: {value: new Date, disabled: true},
          assetNumber: {value: this.navigatorService.generateKey(this.keyTypes.WORK_ORDER_ID), disabled: true},
          dateScheduled: {value: this.viewableDateScheduled, disabled: true},
          desc: [ '' , Validators.required],
          operational_status: ['', Validators.required],
          gallery: [[]]
        }),

        assetInfo: this.fb.group({
          id: [ { value: this.navigatorService.generateKey(this.keyTypes.ASSET_ID), disabled: true }, Validators.required],
          title: [ { value: this.assetItem.title, disabled: true }, Validators.required],
          barcode: [ { value: this.assetItem.barcode, disabled: true }, Validators.required],
          located_at: [ null, Validators.required],
          area: [ '' ],
          model: [ { value: this.assetItem.model, disabled: true }, Validators.required],
          serial_number: [ '', Validators.required],
          isMetered: [ { value: this.assetItem.isMetered, disabled: true }, Validators.required],
          reservation_system: [ { value: this.assetItem.reservation_system, disabled: true }, Validators.required],
        }),
      }); 
    }

    submit() {
      if(this.isAssetCompleted) {
        let dialogData: DialogNewAsset = {
          isLoopBack: false,
          isCompleted: this.isAssetCompleted,
          gallery: this.submitForm.get("basic")['controls'].gallery.value,
          // workOrderData: this.createWorkOrderObject()
          assetData: {
              originatorId: this.submitForm.get("basic")['controls'].originatorId.value,
              originationDate: this.submitForm.get("basic")['controls'].originationDate.value,
              companyId: this.navigatorService.getCompanyId(),
              custom_fields: [],
              
              lockedFields: {
                id: this.submitForm.get("assetInfo")['controls'].id.value,
                title: this.submitForm.get("assetInfo")['controls'].title.value,
                barcode: this.submitForm.get("assetInfo")['controls'].barcode.value,
                price: null,
                desc: this.submitForm.get("basic")['controls'].desc.value,
                located_at: this.submitForm.get("assetInfo")['controls'].located_at.value,
                area: this.submitForm.get("assetInfo")['controls'].area.value,
                gallery: [],
                dateLastChanged: new Date,
                model: this.submitForm.get("assetInfo")['controls'].model.value,
                serial_number: this.submitForm.get("assetInfo")['controls'].serial_number.value,
                isMetered: this.submitForm.get("assetInfo")['controls'].isMetered.value,
                operational_status: this.submitForm.get("basic")['controls'].operational_status.value,
                availability: true,
                reservation_system: this.submitForm.get("assetInfo")['controls'].reservation_system.value,
                work_orders: [],
              }
          }
      };

        this.matDialogRef.close(dialogData);
      } else {
        this.close();
      }
    }

    assetCompleted() {
      this.isAssetCompleted = true;
    }

    close() {
      this.matDialogRef.close();
    }

    public reset() {
      this.horizontalStepper.reset(); 
      
      this.submitForm.reset({
        
      });   
    }

    public onSelectionChange(e:any) { 
      console.log("Forward");
      if(e.selectedIndex == 4) {   
        this.horizontalStepper._steps.forEach(step => step.editable = false);
        console.log(this.submitForm.value);      
      }
    }

    public operationalStatusChange(event) {
      
    }

    public uploadImage(): void {
      let images: Array<any> = this.submitForm.get("workOrder")['controls'].gallery.value;

      // Image upload test (DELETE FOR PRODUCTION)
      this.imageHandlerService.uploadFile(images[0].file, this.navigatorService.generateKey(this.keyTypes.IMAGE_ID));
    }

    public getImage(): void {
      // Image get test (DELETE FOR PRODUCTION)
      this.imageHandlerService.getFile("18249938d0acdec15e300dd9").subscribe(img => {
        this.imageTest = img;
      });
    }

    public generateBarcode(): void {
      let barcode: string = this.navigatorService.generateKey(this.keyTypes.BARCODE_UPC_A);
      this.submitForm.get("assetInfo").get("barcode").setValue(barcode);
      console.log("New Barcode: " + barcode);
    }

    getContrast(hexcolor) {

      // If a leading # is provided, remove it
      if (hexcolor.slice(0, 1) === '#') {
        hexcolor = hexcolor.slice(1);
      }
    
      // If a three-character hexcode, make six-character
      if (hexcolor.length === 3) {
        hexcolor = hexcolor.split('').map(function (hex) {
          return hex + hex;
        }).join('');
      }
    
      // Convert to RGB value
      var r = parseInt(hexcolor.substr(0,2),16);
      var g = parseInt(hexcolor.substr(2,2),16);
      var b = parseInt(hexcolor.substr(4,2),16);
    
      // Get YIQ ratio
      var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    
      // Check contrast
      return (yiq >= 128) ? 'black' : 'white';
    
    }


    // Used for creatig test data
    createWorkOrderObject(): void {

      // return {
      //   technicianId: this.assignedId,
      //   originatorId: this.submitForm.get("workOrder").get("originatorId").value,
      //   workOrderId: this.submitForm.get("workOrder").get("workOrderNumber").value,
      //   companyId: this.navigatorService.getCompanyId(),

      //   originationDate: this.submitForm.get("workOrder").get("originationDate").value,
      //   timeStretch: this.submitForm.get("priority").get("timeStretch").value,
      //   custPocName: "",
      //   custPocPhone: null,
      //   custPocEmail: "",
      //   custFirstName: this.submitForm.get("customerInfo").get("custFirstName").value,
      //   custMiddleName: '',
      //   custLastName: this.submitForm.get("customerInfo").get("custLastName").value,
      //   custEmail: this.submitForm.get("customerInfo").get("custEmail").value,
      //   custPhone: this.submitForm.get("customerInfo").get("custPhone").value,
      //   custAddress: {
      //     street: this.submitForm.get("customerInfo").get("custStreet").value,
      //     city: "",
      //     state: this.submitForm.get("customerInfo").get("custState").value,
      //     zip: this.submitForm.get("customerInfo").get("custZip").value
      //   },
      //   custBillingAddress: {
      //     street: this.submitForm.get("customerInfo").get("custStreet").value,
      //     city: "",
      //     state: this.submitForm.get("customerInfo").get("custState").value,
      //     zip: this.submitForm.get("customerInfo").get("custZip").value
      //   },
      //   custBillAmount: 0,
      //   description: this.submitForm.get("workOrder").get("desc").value,
      //   dateContactLog: [
      //     new Date
      //   ],
      //   dateInitialContact: new Date,
      //   dateScheduled: this.dateScheduled,
      //   priority: this.submitForm.get("priority").get("priority").value,
      //   skillLvl: this.submitForm.get("priority").get("skillLvl").value,
      //   specialNotes: this.submitForm.get("priority").get("specialNotes").value,
      //   status: 1,
      //   foreign_work_orders: [],
      //   isAutoGenerated: false,
      //   isCompleted: false,
      //   isPaid: false,
      //   customFields: []
      // }
    }


  }